<template>
  <div class="">
    <m-single-product-wrapper @product="dataReady" :product-link="productLink">
      <template v-slot="{product}">
        <div class="container-fluid pt-5">
          <div class="border container single-product-background-1 rounded pb-4">
            <div class="row">
              <m-h2 class="h4 pt-3 pr-3"> {{ product.name }}</m-h2>
            </div>
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12">
                <hr class=""/>
                دسته بندی:

                <span v-for="(category, index) in product.category" :key="index">
            <router-link class="text-decoration-none text-secondary"
                         :to="categoryLink ? { name: 'Products', query: { page: 1, category: category.slug, category_column: 'slug' }, } : '#'">
              <span class="text-secondary">{{ category.name }}</span>
            </router-link>
            <span class="text-decoration-none mx-1" v-if="index < product.category.length - 1">/</span>
          </span>
                <p class="mt-3" v-if="product.brand">
                  برند:
                  <router-link v-if="product.brand" class="text-decoration-none text-secondary"
                               :to="brandLink ? { name: 'Products', query: { page: 1, brand: product.brand.slug , brand_column: 'slug'}, } : '#'"
                  >
                    <span class="text-secondary text-decoration-none">{{ product.brand.name }}</span>
                  </router-link>
                  <span v-else class="text-secondary text-decoration-none">{{ product.brand.name }}</span>
                </p>

                <div class="col-12">
                  <m-wish-list-button-1 :itemable_id="product.id"/>
                </div>

              </div>

              <div class="col-12 col-sm-12 col-md-5">
                <div class="discount custom-z-index"
                     v-if="(findAttributeOnSiteInfo('deliver_price')[0] == 0 || product.delivery_amount == 0) && product.is_digital == 0">
                  <h6 class="m-auto">
                    ارسال رایگان
                  </h6>
                </div>

                <swiper
                    :spaceBetween="10"
                    :navigation="true"
                    :thumbs="{ swiper: thumbsSwiper }"
                    :modules="modules"
                    class="mySwiper2"
                >
                  <swiper-slide>
                    <img
                        class="pr-2 img-slider"
                        :src="product.thumbnail"
                        :alt="product.name"
                    />
                  </swiper-slide>

                  <swiper-slide v-for="img in product.images" :key="img.id">
                    <img
                        class="pr-2 img-slider"
                        :src="img.file"
                        :alt="product.name"
                    />
                  </swiper-slide>

                </swiper>

              </div>


              <div class="col-12 col-sm-12 col-md-4 align-self-end mx-auto justify-content-center text-center p-3">


                <m-single-product-price-wrapper :digital-shopping-cart-text="digitalShoppingCartText"
                                                :physical-shopping-cart-text="physicalShoppingCartText"
                                                :product="product">
                  <template v-slot="{timing,quantity,addToCartFunction,buttonText}">

                    <div class="text-center col-lg-12">
                      <div class="row  ">


                        <div class="col-lg-12" v-if="timing">
                          <div class="col-lg-12" v-if="quantity">
                            <m-single-product-price2
                                :buttonText="buttonText"
                                :addToCartFunction="addToCartFunction"
                                :product="product"
                            />
                          </div>

                          <div class="w-100" v-else>
                            <m-product-price100 class="text-dark" :product="product"/>
                            <span class="text-center">موجودی محصول به پایان رسیده است.</span>
                          </div>


                        </div>
                        <div class="w-100" v-else>
                          <m-product-price100 class="text-dark" :product="product"/>
                          <span class="text-center ">زمان سفارش این محصول به پایان رسیده است.</span>
                        </div>

                      </div>
                    </div>


                  </template>
                </m-single-product-price-wrapper>


              </div>


            </div>
          </div>

          <div class="container">
            <div class=" row mt-3">


              <ul class="nav text-center col-lg-12 nav-pills mb-3" id="pills-tab" role="tablist">
                <li class="nav-item col" role="presentation">
                  <a class="nav-link active" id="pills-detail-tab" data-toggle="pill" href="#pills-detail" role="tab"
                     aria-controls="pills-detail" aria-selected="true">مشخصات</a>
                </li>
                <li class="nav-item col" role="presentation">
                  <a class="nav-link" id="pills-description-tab" data-toggle="pill" href="#pills-description" role="tab"
                     aria-controls="pills-description" aria-selected="false">شرح محصول</a>
                </li>
              </ul>

              <div class="tab-content col-lg-12 border p-2 rounded" id="pills-tabContent">
                <div class="tab-pane fade show active" id="pills-detail" role="tabpanel"
                     aria-labelledby="pills-detail-tab">
                  <single-product-table-feature1 :product="product"/>
                </div>

                <div class="tab-pane fade" id="pills-description" role="tabpanel"
                     v-html="processContent(product.description)" aria-labelledby="pills-description-tab">

                </div>
              </div>


            </div>
          </div>


          <div class="container my-5 single-product-background-3">
            <h5>محصولات مرتبط</h5>
            <m-product-slider1 :product-card-name="productCardName" :product-categories="productCategories(product)"
                               :wait-for-category="true"/>
          </div>

        </div>
      </template>
    </m-single-product-wrapper>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {Swiper, SwiperSlide} from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import {Navigation, FreeMode, Thumbs} from "swiper";
import "swiper/css/free-mode"
import "swiper/css/thumbs"


import mSingleProductWrapper from "../../Wrappers/SingleProductWrapper";
import mSingleProductPriceWrapper from "../../Product/SingleProductPriceWrapper";
import mH2 from "../../Tags/H2";
import mImg from "../../Tags/Img.vue";
import mProductPrice100 from "../../Product/ProductPrice100";
import mSingleProductPrice2 from "../../Product/SingleProductPrice2";
import mRelatedProducts301 from "../RelatedProduct/RelatedProducts301";
import SingleProductTableFeature1 from "./Components/SingleProductTableFeature1.vue";
import mProductSlider1 from "../ProductSlider/ProductSlider1.vue";
import mWishListButton1 from "../../WishList/Button/WishListButton1.vue";

export default {
  name: "SingleProduct1",
  props: {
    productLink: {
      default: null
    },
    relatedProducts: {
      default: false
    },
    digitalShoppingCartText: {
      default: "افزودن"
    },
    physicalShoppingCartText: {
      default: "افزودن"
    },
    relatedProductsText: {
      default: "محصولات مرتبط"
    },
    comment: {
      default: true
    },
    comment_title: {
      default: "نظرات"
    },
    categoryLink: {
      default: true
    },
    brandLink: {
      default: true
    },
    productCardName: {
      default: 'm-product-card309',
    },
  },
  components: {
    mProductSlider1,
    mSingleProductWrapper,
    mH2,
    mSingleProductPriceWrapper,
    mProductPrice100,
    Swiper,
    SwiperSlide,
    mSingleProductPrice2,
    mRelatedProducts301,
    mImg,
    SingleProductTableFeature1,
    mWishListButton1,
  },
  data() {
    return {
      fields: [
        {key: "name", label: ""},
        {key: "feature_value", label: ""},
      ],
      swiperOptions: {
        slidesPerView: 1,
        effect: "fade",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: true,
        },

      },
      swiperOptionThumbs: {
        notNextTick: true,
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      }
    };
  },
  setup() {
    let thumbsSwiper = null;

    const setThumbsSwiper = (swiper) => {
      thumbsSwiper = swiper;
    }

    return {modules: [FreeMode, Navigation, Thumbs], setThumbsSwiper};
  },
  watch: {
    $route: {
      handler() {
        this.$store.dispatch("Product/getProduct", this.$route.params.name);
      },
    },
  },
  computed: {
    ...mapGetters({
      product: "Product/getProduct",
    }),
    IsAuthenticated() {
      return this.$store.getters["User/isAuthenticated"];
    }
  },
  methods: {
    dataReady(product) {
    },
    productCategories(product) {
      let categories = product.category

      if (categories != undefined) {
        categories = categories.map(item => {
          return item.slug;
        })
        return categories
      }

      return null

    },
  },
};
</script>

<style>

.customize-tab-colors .nav-item a {
  color: var(--dark) !important;
}
</style>

<style scoped>
.tabs {
  width: 100%;
}

.discount {
  margin: 10px;
  padding: 10px;
  background-color: var(--secondary);
  color: white;
  position: absolute;
  left: 20px;
  top: 7px;
  border-radius: 14px 14px 0px 14px;
  z-index: 10;
}

.img-slider {
  width: 100%;
  object-fit: contain;
  height: 100%;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
  background: white;
}

.gallery-top {
  height: 80% !important;
  width: 100%;
}

.gallery-thumbs {
  height: 20% !important;
  box-sizing: border-box;
  padding: 10px 0;
}

.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}

.gallery-thumbs .swiper-slide-active {
  opacity: 1;
}
</style>